export const TEMPERATURE_OTHER = { id: 'other', name: 'Other' };
